export default __webpack_public_path__ + "static/media/rnr-sports-table-22-cn.8a343796.webp";